<template>
    <div>
        <div>
            <div class="block font-semibold text-gray-700 mb-2">
                <svg class="inline w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                Name on Account
            </div>

            <div class="flex -space-x-px">
                <div class="w-1/2 flex-1 min-w-0 pr-1">
                    <input :value="$attrs['first_name']"
                        :class="{ [`focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 border-gray-300`]: ! error, 'focus:ring-red-400 focus:border-red-400 border-red-300': error }"
                        @input="$emit('update:first_name', $event.target.value)"
                        type="text"
                        :name="`first_name_${unique}`"
                        :id="`first_name_${unique}`"
                        class="py-3 px-4 rounded bg-gray-50 relative block w-full bg-transparent focus:z-10 sm:text-sm"
                        placeholder="First Name" required>
                </div>
                <div class="flex-1 min-w-0 pl-1">
                    <input :value="$attrs['last_name']"
                        :class="{ [`focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 border-gray-300`]: ! error, 'focus:ring-red-400 focus:border-red-400 border-red-300': error }"
                        @input="$emit('update:last_name', $event.target.value)"
                        type="text"
                        :name="`last_name_${unique}`"
                        :id="`last_name_${unique}`"
                        class="py-3 px-4 rounded bg-gray-50 relative block w-full bg-transparent focus:z-10 sm:text-sm"
                        placeholder="Last Name" required>
                </div>
            </div>
        </div>

        <div class="mt-4">
            <div class="flex -space-x-px">
                <div class="w-1/2 flex-1 min-w-0 pr-1">
                    <label for="routing_number" class="block font-semibold text-gray-700 mb-2">
                        Routing Number
                    </label>
                    <input :value="$attrs['routing_number']"
                        :class="{ [`focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 border-gray-300`]: ! error, 'focus:ring-red-400 focus:border-red-400 border-red-300': error }"
                        @keyup="validateNumber($event.target.value, 'routing_number')"
                        maxlength="9"
                        type="text"
                        name="routing_number"
                        :id="`routing_number_${unique}`"
                        :ref="`routing_number_${unique}`"
                        class="py-3 px-4 rounded bg-gray-50 relative block w-full bg-transparent focus:z-10 sm:text-sm"
                        placeholder="Routing Bank" required>
                </div>
                <div class="flex-1 min-w-0 pl-1">
                    <label for="account_number" class="block font-semibold text-gray-700 mb-2">
                        Account Number
                    </label>
                    <input :value="$attrs['account_number']"
                        :class="{ [`focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 border-gray-300`]: ! error, 'focus:ring-red-400 focus:border-red-400 border-red-300': error }"
                        @keyup="validateNumber($event.target.value, 'account_number')"
                        maxlength="17"
                        type="text"
                        name="account_number"
                        :id="`account_number_${unique}`"
                        :ref="`account_number_${unique}`"
                        class="py-3 px-4 rounded bg-gray-50 relative block w-full bg-transparent focus:z-10 sm:text-sm"
                        placeholder="Account Number" required>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['error'],

        created() {
            this.unique = Math.floor(Math.random() * 100);
        },

        data() {
            return {
                unique: null
            }
        },

        methods: {
            validateNumber(valueToValidate, fieldName) {
                valueToValidate.match(/(\D*)\d*\/*\d*(.*)/)
                    .slice(1)
                    .filter(i => !! i)
                    .forEach(match => valueToValidate = valueToValidate.replaceAll(match, ''));

                this.$refs[`${fieldName}_${this.unique}`].value = valueToValidate;
                this.$emit(`update:${fieldName}`, valueToValidate);
            }
        }
    }
</script>